import api from './api';
import { FILE } from './endpoints';

const postMultiple = files => {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));

  return api.post(`${FILE}/multiple/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default {
  postMultiple,
};
